import type { SimulatorRoundSettings } from "../../../domain/simulator/simulator-types.js";
import type { CourseChoice, WizardState } from "./wizard-state.js";
import type { CourseSnapshot } from "../../../domain/round/round-types.js";

export function simulatorSetupProblem(state: WizardState): string | null {
  if (state.kind !== "simulator") return null;
  if (!state.course?.dataConfirmed)
    return "Confirm the actual simulator course, tee and hole data before starting.";
  if (!state.simulator?.system.trim())
    return "Enter the simulator system you are playing on.";
  if (!state.simulator.gimmeMode)
    return "Choose gimme off or the agreed distance before starting.";
  if (state.simulator.gimmeMode === "distance") {
    const value = Number(state.simulator.distance.replace(",", "."));
    if (!Number.isFinite(value) || value <= 0 || value > 30)
      return "Enter the actual gimme distance, greater than zero and no more than 30.";
  }
  return null;
}

export function simulatorRules(
  state: WizardState,
): SimulatorRoundSettings | undefined {
  if (state.kind !== "simulator") return undefined;
  const problem = simulatorSetupProblem(state);
  if (problem) throw new Error(problem);
  const value = state.simulator!;
  return {
    version: 1,
    system: value.system.trim(),
    gimme:
      value.gimmeMode === "off"
        ? { mode: "off", distance: null, unit: null }
        : {
            mode: "distance",
            distance: Number(value.distance.replace(",", ".")),
            unit: value.unit,
          },
    catalog: state.course?.catalog ?? null,
    confirmedAt: new Date().toISOString(),
  };
}

export function simulatorChoiceSnapshot(choice: CourseChoice): CourseSnapshot {
  if (choice.kind !== "simulator" || !choice.courseId || !choice.holes?.length)
    throw new Error("Load the actual simulator tee before starting.");
  return {
    id: choice.courseId,
    source: "simulator",
    name: choice.courseName,
    teeName: choice.teeName,
    rating: choice.rating,
    slope: choice.slope,
    holes: structuredClone(choice.holes),
  };
}
